import Cookies from 'js-cookie'
import utils from '@/utils/utils'
import bus from '@/utils/bus'
import { Toast } from 'vant'

export const setCacheData = ($name, $data) => {
  localStorage.setItem($name, JSON.stringify($data))
}
export const getCacheData = ($name) => {
  return localStorage.getItem($name) ? JSON.parse(localStorage.getItem($name)) : false
}
export const clearCacheData = ($name) => {
  JSON.parse(localStorage.removeItem($name))
}
export const setFirstData = () => {
  localStorage.setItem('User-First', true)
}
export const getFirstData = () => {
  return localStorage.getItem('User-First')
}

export function checkVersion($ver) { // 检查与自定义版本号是否匹配，大小
  const versionArr = Cookies.get('env') ? JSON.parse(Cookies.get('env')).data.version : '0.0.0' // 判断app版本，小于3.2.2都得死
  const VERSION = versionArr.split('.') // 设备版本号
  let status = false
  // 设备版本号与自定义的目标版本号对比
  if (VERSION[0] * 1 > $ver[0]) {
    status = true
  } else {
    if (VERSION[1] * 1 > $ver[1]) {
      status = true
    } else {
      if (VERSION[2] * 1 > $ver[2]) {
        status = true
      } else { status = false }
    }
  }
  return status
}

export const superLink = ($param = {}) => { // 跳转App，小程序，微信浏览器，H5等逻辑判断
  const { des, skuid, link } = JSON.parse($param)
  console.log('superLink', des, skuid, link)
  if (utils.isGteatChefbrowser()) { // 判断是否名厨浏览器
    if (!checkVersion([3, 2, 5])) return Toast('您当前使用的软件版本较低，请升级最新版本')
    utils.goAppPage($param) // 打开原生页面
  } else if (utils.is_mini()) { // 小程序
    if (des !== 'h5') {
      utils.goMiniPage(`pages/${des}/main?id=${skuid}`) // 打开小程序页面
    } else { // h5的话直接用webview渲染
      location.href = link
    }
  } else if (utils.is_weixn()) { // 微信浏览器
    if (utils.isiOS()) { // 判断是ios，打开前提示
      const answer = window.confirm(`您将打开名厨MINGCHU`)
      answer && utils.goDown(des, link, skuid)
    } else { // 安卓需要弹个引导框
      bus.$emit('guideShow', true)
    }
  } else { // 都不满足去下载页面
    utils.goDown(des, link, skuid)
  }
}
